import { Component, Prop, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faCircleInfo,
} from '@fortawesome/free-solid-svg-icons'
import {
	faLinkedinIn,
	faInstagram,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons'

import { genId } from '@/helpers/gen-id'
import api from '@/helpers/fetch'
import Fuse from 'fuse.js'

library.add(
	faTrashAlt,
	faClose,
	faFilePdf,
	faArrowRightLong,
	faCheck,
	faGlobe,
	faLinkedinIn,
	faInstagram,
	faYoutube,
	faCircleInfo,
)

@Component({
	components: {
		Loader,
		vSelect,
	},
})
export default class CreateUser extends Vue {
	form = {
		name: '',
		email: '',
		group: '',
		permissionGroup: '',
		groups: [] as Array<any>,
		block_date: null,
	}

	options = {
		groups: [] as Array<any>,
	}

	submitLoading = false

	get minBlockDate() {
		return new Date()
	}

	fuseSearch(options, search) {
		const fuse = new Fuse(options, {
			keys: ['name'],
			shouldSort: true,
			ignoreLocation: true,
		})
		// @ts-ignore
		return search.length
			? fuse.search(search).map(({ item }) => item)
			: options
	}

	async loadGroups() {
		const res = await api.get('/api/groups')
		this.options.groups = []
		this.options.groups.push(...res.data)
	}

	async addGroup() {
		if (!this.form.group) return
		const duplicate = this.form.groups.find(
			(group) => group.id === this.form.group,
		)
		if (duplicate) {
			this.$bvToast.toast('Grupo já Incluído', {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
			return
		}

		const group = this.options.groups.find(
			(group) => group.id === this.form.group,
		)

		this.form.groups.push({ name: group.name, id: this.form.group })
		this.form.group = ''
	}

	async removeGroup(index) {
		this.form.groups.splice(index, 1)
	}

	async submit() {
		if (!this.form.email || !this.form.name) return
		this.submitLoading = true
		const body = {
			name: this.form.name,
			email: this.form.email,
			permissionGroup: this.form.permissionGroup,
			groups: this.form.groups.map((group) => group.id),
			block_date: this.form.block_date,
		}
		const res = await api.post('/api/users', body)
		this.submitLoading = false

		if (res.ok) {
			this.$bvToast.toast('Convite criado!', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
			setTimeout(() => {
				this.$router.push('/usuarios')
			}, 1000)
		} else {
			this.$bvToast.toast(
				'Tivemos um erro, verifique se o email já foi cadastrado',
				{
					title: 'Erro',
					variant: 'danger',
					solid: true,
					toaster: 'b-toaster-top-center',
				},
			)
		}
	}

	mounted() {
		this.loadGroups()
	}
}
